import type { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import type { Mesh } from '@babylonjs/core/Meshes/mesh';

export const FLOOR_TOP_OPACITY = 0.8;
export const FLOOR_BOTTOM_OPACITY = 0.1;

/** Oppositely culled faces avoid double blending, including in stereo XR. */
export function applyTempleFloor(floor: Mesh, marble: StandardMaterial): Mesh {
  const top = marble.clone('templeFloorTop');
  top.alpha = FLOOR_TOP_OPACITY;
  top.backFaceCulling = true;
  floor.material = top;
  const underside = floor.clone('templeFloorUnderside', floor.parent)!;
  underside.rotation.x += Math.PI;
  underside.isPickable = false;
  const bottom = marble.clone('templeFloorBottom');
  bottom.alpha = FLOOR_BOTTOM_OPACITY;
  bottom.backFaceCulling = true;
  underside.material = bottom;
  return underside;
}
